import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface RequestDescriptionDialogProps {
  open: boolean
  onClose: () => void
  description: string | undefined
}

const RequestDescriptionDialog: React.FC<RequestDescriptionDialogProps> = ({ open, onClose, description }) => {
  const { formatMessage } = useIntl()

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{formatMessage({ id: 'general.learnMore' })}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color={description ? 'text.primary' : 'text.secondary'} sx={{ whiteSpace: 'pre-wrap' }}>
          {description || formatMessage({ id: 'questionnaire.noDescription' })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{formatMessage({ id: 'general.close' })}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default RequestDescriptionDialog
